import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawalpointlistPage } from './withdrawalpointlist';

@NgModule({
  declarations: [
    WithdrawalpointlistPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawalpointlistPage),
  ],
})
export class WithdrawalpointlistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdrawalpointlist/withdrawalpointlist.module.ts